import { Container, Graphics } from "pixi.js";

export class EffectsLayer extends Container {
  private marker: Graphics | null = null;

  constructor() {
    super();
    this.label = "effects";
  }

  showSelection(x: number, y: number): void {
    this.marker?.destroy();
    this.marker = new Graphics()
      .ellipse(0, 0, 34, 14)
      .stroke({ color: 0x60a5fa, width: 2, alpha: 0.95 });
    this.marker.position.set(x, y);
    this.addChild(this.marker);
  }

  clearSelection(): void {
    this.marker?.destroy();
    this.marker = null;
  }
}
